<script>
  	import rpcjs from 'rpcjs';
	import { title } from './store.js';
	import { getContext, setContext } from 'svelte'
	import pages from 'pages';
	// import pages from other pacakges  here

	// combine all pages
	const allpages = {...pages}

	const { api_init, createUrlStore } = rpcjs.props;
	export let ssrUrl = '';
	setContext('APP', { url: createUrlStore(ssrUrl) });
	const { url } = getContext('APP');
	const pathprefix = $url.pathname.match(/^\/[^\/]*/).at(0);

	title.set("Home");
</script>

<svelte:head>
	<title>automason | {$title}</title>
</svelte:head>

<main>
	{#if $api_init}
		<svelte:component this={allpages[pathprefix]} />
	{/if}
</main>

<style>
	:global(body) {
		font-family: 'Poppins', sans-serif;
		margin: 0;
		padding: 0;
	}
	:global(a) {
		text-decoration: none;
		color: inherit;
	}
	:global(a:hover) {
		text-shadow: .1vw .3vw .2vw lightgrey;
	}
	:global(button) {
		background-color: inherit;
		display: inline-block;
		border: inherit;
		margin: 0;
		padding: 0;
		cursor: pointer;
		text-align: inherit;
		outline: none;
	}
</style>
